import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { getRoutePolicy } from "../lib/routePolicy";

export const RouteIndexing = () => {
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    const policy = getRoutePolicy(pathname);
    let robots = document.querySelector('meta[name="robots"]');
    if (!robots) {
      robots = document.createElement("meta");
      robots.name = "robots";
      document.head.appendChild(robots);
    }
    robots.content = policy.indexable
      ? "index, follow, max-image-preview:large, max-snippet:-1"
      : "noindex, follow";

    if (!policy.indexable) {
      document.querySelectorAll('link[rel="canonical"]').forEach((el) => el.remove());
      const title = policy.status === 404 ? "Page introuvable"
        : policy.path.startsWith("/admin") ? "Espace administrateur"
        : policy.path === "/flyer" ? "Flyer" : "Votre commande";
      document.title = `NOCTUA RIVIERA — ${title}`;
      document.querySelectorAll('meta[name="description"], meta[property="og:description"], meta[name="twitter:description"]').forEach((el) => {
        el.content = policy.status === 404 ? "Cette page n'existe pas. Retrouvez le catalogue Noctua Riviera." : "Espace de service Noctua Riviera.";
      });
      document.querySelectorAll('meta[property="og:title"], meta[name="twitter:title"]').forEach((el) => { el.content = document.title; });
      document.querySelector('meta[property="og:url"]')?.remove();
    }

    // The static identity is retained; the visible React FAQ supplies its own schema.
    const baseSchema = document.getElementById("base-seo-schema");
    if (baseSchema) {
      const data = JSON.parse(baseSchema.textContent);
      data["@graph"] = data["@graph"].filter((node) => node["@type"] !== "FAQPage");
      baseSchema.textContent = JSON.stringify(data);
    }
  }, [pathname]);
  return null;
};